import {svgIconWrapper} from '../svg-icon-wrapper';

import DocusignRegular from './docusign-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <DocusignRegular {...props} />;
}

SvgComponent.iconName = 'docusignRegular';

export const DocusignRegularIcon = svgIconWrapper(SvgComponent);
